import styled,{ keyframes}  from 'styled-components';

let fadeIn = keyframes`
 0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

let Colors = {
	error: "#f7dbd5",
	info: "#e6f7ff",
	warning: "#fff2d4",
	success: "#c9e8de",
	cancel: "#CED9E0"
};

let BorderColor = {
	error: "#ce4523",
	info: "#2965CC",
	warning: "#eb944d",
	success: "#3dac89",
	cancel: "#394B59"
};

const NotificationBanner = styled.div`
	margin-left: 20px;
	width: auto !important;
	min-width: auto !important;
	max-width: calc(100% - 40px);
	.banner {
		position: relative;
		box-sizing: border-box;
		padding: 15px;
		border-radius: 3px;
		border-left-width: 3px;
		border-left-style: solid;
		z-index: 1;
		color: #13191c;
		background-color: ${props => (props.type ? Colors[props.type] : "sky")};
		border-left-color: ${props => (props.type ? BorderColor[props.type] : "sky")};
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;
		/* transition: all 0.5s ease-in-out; */
		animation: ${fadeIn} 0.5s;
		/* transform-origin: top; */
		&.has-dismiss {
			padding-right: 50px;
		}
		&.has-icon {
			padding-left: 50px;
		}
		&:not(.is-sticky) {
			margin-top: 18px;
		}
		&.has-icon::before {
		}
		.content {
			font-weight: normal;
		}
		.dismiss {
			position: absolute;
			right: 15px;
			top: 15px;
			outline: none;
			background: transparent;
			border: none;
			border-radius: 100%;
			font-size: 16px;
			color: #777;
			cursor: pointer;
		}
		.icon {
			position: absolute;
			top: 15px;
			left: 15px;
			font-size: 20px;
			line-height: normal;
			color: ${props => (props.type ? BorderColor[props.type] : "sky")};
		}
	}
`;

export default NotificationBanner;
